import React, { createContext, useContext, useState } from 'react';

interface OnboardingContextType {
  isOnboardingActive: boolean;
  setIsOnboardingActive: (active: boolean) => void;
}

const OnboardingContext = createContext<OnboardingContextType | undefined>(undefined);

export const OnboardingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOnboardingActive, setIsOnboardingActive] = useState(false);

  return (
    <OnboardingContext.Provider value={{ isOnboardingActive, setIsOnboardingActive }}>
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (context === undefined) {
    throw new Error('useOnboarding must be used within OnboardingProvider');
  }
  return context;
};
